import type { IndustryContent } from '@/types/content';
import { getTestimonialsByIndustry } from '../testimonials';

export const cleaningContent: IndustryContent = {
  slug: 'carpet-cleaning',
  name: 'Cleaning Services',
  headline: 'The Operating System for Cleaning Companies',
  subheadline:
    'Schedule recurring services, manage crews, and delight customers—all from one platform built for cleaning professionals.',
  heroImageUrl: '/images/industries/cleaning-hero.webp',
  painPoints: [
    {
      title: 'Recurring schedules are hard to manage',
      description:
        'Weekly, bi-weekly, monthly clients—keeping track of who needs service when is a spreadsheet nightmare.',
      icon: 'calendar-x',
    },
    {
      title: 'High crew turnover disrupts everything',
      description:
        'New cleaners don\'t know client preferences. "Use the back door" and "skip the guest room" details get lost.',
      icon: 'turnover',
    },
    {
      title: 'Quality control is inconsistent',
      description:
        'You can\'t be at every job. When complaints come in, you\'re playing detective to figure out what happened.',
      icon: 'quality',
    },
    {
      title: 'Route inefficiency eats your margins',
      description:
        'Crews zigzag across town wasting time and fuel. With tight margins, every extra mile costs you.',
      icon: 'route',
    },
  ],
  features: [
    {
      title: 'Recurring Service Management',
      description:
        'Set up weekly, bi-weekly, or custom schedules that automatically populate your calendar. Never miss a service.',
      icon: 'recurring',
    },
    {
      title: 'Customer Preferences',
      description:
        'Store access codes, pet info, special instructions, and room-by-room notes. Every cleaner arrives prepared.',
      icon: 'notes',
    },
    {
      title: 'Quality Checklists',
      description:
        'Room-by-room digital checklists with photo requirements. Ensure consistent quality at every job.',
      icon: 'checklist',
    },
    {
      title: 'Route Optimization',
      description:
        'Automatically build the most efficient routes for your crews. Cut drive time and fit more jobs per day.',
      icon: 'route',
    },
    {
      title: 'Team Scheduling',
      description:
        'Assign crews based on skills, location, and availability. Handle call-outs and last-minute changes easily.',
      icon: 'dispatch',
    },
    {
      title: 'Customer Portal',
      description:
        'Let clients book, reschedule, and pay online. Reduce phone calls and improve customer satisfaction.',
      icon: 'portal',
    },
  ],
  testimonial: getTestimonialsByIndustry('carpet-cleaning')[0],
  stats: [
    { label: 'Scheduling Time Saved', value: '70%' },
    { label: 'More Jobs Per Crew', value: '+25%' },
    { label: 'Customer Retention', value: '94%' },
    { label: 'Reduced No-Shows', value: '-80%' },
  ],
  seo: {
    title: 'Cleaning Service Software | Scheduling & Management | Omniforge',
    description:
      'Cleaning business software for maid services, janitorial, and carpet cleaning companies. Recurring schedules, route optimization, and quality tracking. Start your free trial.',
    keywords: [
      'cleaning service software',
      'maid service software',
      'janitorial software',
      'carpet cleaning software',
      'cleaning business management',
      'cleaning scheduling software',
    ],
  },
};
